<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="main-container">
          <div class="row">
            <figure class="enquiry_holder">
              <div class="image">
                <img src="/static/img/enq_dp.jpg" alt="Enquiry"/>
              </div>
              <figcaption>
                <div class="date"><span class="day">28</span><span class="month">Oct, 2016</span></div>
                <div class="enq_info">
                  <h3>John Doe</h3>
                  <h5>Ikeja, Lagos</h5>
                  <h4>08072128239</h4>
                </div>
                <p>
                  I don't need to compromise my principles, they don't have the slightest bearing on what happens to me anyway.
                </p>
              </figcaption>
              <footer>
                <div class="views"><i class="fa fa-info"></i>Resolved</div>
              </footer>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import {mapGetters, mapActions} from 'vuex'

  export default {
    data() {
      return {
        responseData: '',
        errors: '',
        componentName: '',
      };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
    },
  };

</script>
<style>
.widget_box{
  min-height: auto !important;
}
figure.enquiry_holder {
  font-family: 'Poppins', Arial, sans-serif;
  color: #fff;
  position: relative;
  float: left;
  overflow: hidden;
  margin: 10px 1%;
  width: 100%;
  background-color: #ffffff;
  color: #000000;
  text-align: left;
  font-size: 16px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
}
figure.enquiry_holder * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
figure.enquiry_holder .image {
  max-height: 220px;
  overflow: hidden;
}
figure.enquiry_holder img {
  width: 100%;
  vertical-align: top;
  position: relative;
}
figure.enquiry_holder figcaption {
  margin: -40px 15px 0;
  padding: 15px ;
  position: relative;
  background-color: #ffffff;
}
figure.enquiry_holder .date {
  background-color: #2980b9;
  top: 6px;
  color: #fff;
  left: 15px;
  min-height: 48px;
  min-width: 48px;
  position: absolute;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
}
figure.enquiry_holder .date span {
  display: block;
  line-height: 24px;
}
figure.enquiry_holder .date .month {
  font-size: 14px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}
figure.enquiry_holder h3,
figure.enquiry_holder p {
  margin: 0;
  padding: 0;
}

figure.enquiry_holder .enq_info {
  margin-left: 105px;
}

figure.enquiry_holder h3 {
  /* min-height: 50px; */
  margin-bottom: 10px;
  /* margin-left: 100px; */
  display: inline-block;
  font-weight: 600;
  text-transform: uppercase;
}

figure.enquiry_holder h4 {
  /* min-height: 50px; */
  margin-bottom: 10px;
  margin-left: 5px;
  text-transform: uppercase;
  font-size: 15px;
}
figure.enquiry_holder h5 {
  /* min-height: 50px; */
  margin-bottom: 10px;
  margin-left: 5px;
  text-transform: uppercase;
  display: inline-block;
  font-size: 12px;
  color: #888;
  font-weight: bold;
}

figure.enquiry_holder p {
  font-size: 0.9em;
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: 1.6em;
}
figure.enquiry_holder footer {
  padding: 0 25px;
  background-color: #2980b9;
  color: #e6e6e6;
  font-size: 0.8em;
  line-height: 30px;
  text-align: right;
}
figure.enquiry_holder footer > div {
  display: inline-block;
  margin-left: 10px;
}
figure.enquiry_holder footer i {
  color: rgba(255, 255, 255, 0.2);
  margin-right: 5px;
}
figure.enquiry_holder a {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  z-index: 1;
}
figure.enquiry_holder:hover img,
figure.enquiry_holder.hover img {
  -webkit-transform: scale(1.15);
  transform: scale(1.15);
}
</style>




// WEBPACK FOOTER //
// src/components/pages/enquiries/view.vue